import { render, staticRenderFns } from "./AuditTrailListView.vue?vue&type=template&id=f54a9a16"
import script from "./AuditTrailListView.vue?vue&type=script&lang=js"
export * from "./AuditTrailListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports